<template>
  <Page
    class="my-page themeable"
    :total="totalCount" 
    :current.sync="setCurrentPage"
    :page-size-opts="pageArr"
    show-total
    show-elevator
    :page-size="length" 
    @on-change="changePage" 
    @on-page-size-change="pageSizeChange"
    placement="top"
    show-sizer>
  </Page>
</template>

<script>
export default {
  // 把父组件的数据总条数传过来
  props: ['totalCount','returnFirstPageIndex'],
  data() {
    return {
      length: 10, // 每页显示数据条数
      currentPage: 0, // 当前页码
      setCurrentPage: 1,
      pageArr:[10,20,50,100,200]//分页配置
    }
  },
  watch: {
      returnFirstPageIndex(val) {
        this.setCurrentPage = 1;
      }
    },
  computed: {
    // 计算数据开始的索引
    start() {
      return this.currentPage * this.length;
    }
  },

  created() {
    // 创建的时候先查询一下表格
    //this.$emit('callback', { start: this.start, length: this.length })
  },

  methods: {
    // 页码改变事件
    changePage(index) {
      this.currentPage = index - 1;
      this.$emit('callback', { start: this.start, length: this.length })
    },

    // 数据条数改变事件
    pageSizeChange(pageSize) {
      this.length = pageSize;
      this.currentPage = 0;
      this.$emit('callback', { start: this.start, length: this.length })
    },
  }
}
</script>

<style lang="scss" scoped>
  .my-page {
    text-align: right !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/myPage.vue